import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {FormBuilder} from '@angular/forms';
import {debounceTime} from 'rxjs/operators';
import {RewardCodeService} from './reward-code.service';
import {environment} from '../../../../environments/environment';

@Component({
  selector: 'app-reward-code',
  templateUrl: './reward-code.component.html',
  styleUrls: ['./reward-code.component.scss'],
})
export class RewardCodeComponent implements OnInit {

  constructor(private route: ActivatedRoute,
              private router: Router,
              private formBuilder: FormBuilder,
              private rewardCodeService: RewardCodeService) {
    this.phone = this.route.snapshot.queryParams.phone;
    this.campaignId = this.route.snapshot.params.campaignId;
  }
  phone: any;
  campaignId: any;
  form: any;
  listRewardCode: any = [];
  ngOnInit() {
    this.form = this.formBuilder.group({
      keySearch: null
    });
    this.form.get('keySearch').valueChanges.pipe(debounceTime(500)).subscribe(val => {
      this.offset = 1;
      this.fetchData('search');
    });
    this.fetchData('search');
  }

  async onViewCampaign() {
    // tslint:disable-next-line:variable-name
    const is_change_phone = JSON.parse(localStorage.getItem('is_change_phone'));
    // tslint:disable-next-line:max-line-length
    const businessID = this.route.snapshot.queryParams.business_id;
    await this.router.navigate([`campaign/${this.campaignId}`],
        {queryParams: {
            phone: this.phone,
            business_id: businessID
        }
        });
  }
  totalCount = 0;
  offset = 1;
  async onScrollDown() {
    console.log("bottom")
    console.log("totalCount", this.totalCount)
    console.log("offset", this.offset)
    if (this.totalCount > this.listRewardCode?.length) {
      this.offset = this.offset + 1;
      this.fetchData('scroll');
    }
  }

  fetchData(type?: string) {
    const businessID = this.route.snapshot.queryParams.business_id;
    if (this.phone && businessID) {
      this.rewardCodeService.getRewardCode({
        phone: this.phone,
        campaignId: this.campaignId,
        businessId: businessID,
        keySearch: this.form.get('keySearch').value ? this.form.get('keySearch').value.trim() : '',
        page: this.offset,
        size: 10,
      }).subscribe((res: any) => {
        if (res?.statusCode === 200) {
          if (type === 'search') {
            this.listRewardCode = res?.data?.rows || [];
          } else {
            this.listRewardCode = this.listRewardCode.concat(res?.data?.rows) || [];
          }
            this.totalCount = parseInt(res?.data?.count) || 0;
            // this.listRewardCode = [
            //   {
            //     "code": "abcdeF",
            //     "confirmedAt": "17:48 11/06/2025",
            //     "status": "Hợp lệ"
            //   },
            //   {
            //     "code": "DRBS3Y",
            //     "confirmedAt": "16:02 06/06/2025",
            //     "status": "Hợp lệ"
            //   },
            //   {
            //     "code": "KU7TGI",
            //     "confirmedAt": "11:12 05/06/2025",
            //     "status": "Đã dùng"
            //   },
            //   {
            //     "code": "0JE2KR",
            //     "confirmedAt": "09:21 04/06/2025",
            //     "status": "Đã dùng"
            //   },
            //   {
            //     "code": "CEDR6Z",
            //     "confirmedAt": "09:21 04/06/2025",
            //     "status": "Đã dùng"
            //   },
            //   {
            //     "code": "OBXNDH",
            //     "confirmedAt": "11:29 11/06/2025",
            //     "status": "Hợp lệ"
            //   },
            //   {
            //     "code": "92QFU4",
            //     "confirmedAt": "09:21 04/06/2025",
            //     "status": "Đã dùng"
            //   },
            //   {
            //     "code": "0TEMCQ",
            //     "confirmedAt": "09:21 04/06/2025",
            //     "status": "Đã dùng"
            //   },
            //   {
            //     "code": "76ZTCJ",
            //     "confirmedAt": "09:21 04/06/2025",
            //     "status": "Đã dùng"
            //   },
            //   {
            //     "code": "SCBZ5A",
            //     "confirmedAt": "09:21 04/06/2025",
            //     "status": "Đã dùng"
            //   },
            //   {
            //     "code": "FOKHGA",
            //     "confirmedAt": "09:21 04/06/2025",
            //     "status": "Đã dùng"
            //   },
            //   {
            //     "code": "BCEH70",
            //     "confirmedAt": "09:56 11/06/2025",
            //     "status": "Hợp lệ"
            //   },
            //   {
            //     "code": "H7J95E",
            //     "confirmedAt": "09:21 04/06/2025",
            //     "status": "Hợp lệ"
            //   },
            //   {
            //     "code": "DO6N4I",
            //     "confirmedAt": "11:12 05/06/2025",
            //     "status": "Đã dùng"
            //   }
            // ]
        }
      });
    }
  }

}
